export default {
	'ESC':   27,
	'LEFT':  37,
	'RIGHT': 39
}